import { render, staticRenderFns } from "./DisplayOptions.vue?vue&type=template&id=2eecd780&scoped=true&"
import script from "./DisplayOptions.vue?vue&type=script&lang=js&"
export * from "./DisplayOptions.vue?vue&type=script&lang=js&"
import style0 from "./DisplayOptions.vue?vue&type=style&index=0&id=2eecd780&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eecd780",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemIcon } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VImg,VList,VListItem,VListItemContent,VListItemIcon,VListItemTitle})
